export default __webpack_public_path__ + "static/media/BeforeandAfter.6517882e.png";